import { useParams } from 'react-router-dom';
import useWorkflowDoc from '@actions/services/firestore/browser/workflow/use';
import EntityBreadcrumb from '../EntityBreadcrumb';
import { WorkflowCrumbProps } from './types';

const WorkflowCrumb = ({ param, isCurrentPage = false }: WorkflowCrumbProps) => {
    const params = useParams();
    const workflowId = params[param];
    const agentId = params.agentId;
    const versionId = params.versionId;

    const { data: workflow, isLoading } = useWorkflowDoc(workflowId || '', {
        disabled: !workflowId,
    });

    const label = isLoading ? '...' : workflow?.name || `Workflow ${workflowId?.slice(0, 8)}...`;

    // Navigate to builder for the current version
    const href =
        agentId && workflowId && versionId
            ? `/agents/${agentId}/workflows/${workflowId}/versions/${versionId}/builder`
            : undefined;

    return (
        <EntityBreadcrumb
            label={label}
            entityId={workflowId || ''}
            entityType="Workflow"
            href={href}
            isCurrentPage={isCurrentPage}
            isLoading={isLoading}
        />
    );
};

export default WorkflowCrumb;
